import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import Iconify from '../../../../Iconify';
import useRealNode from '../../../../../hooks/useRealNode';
import { ModalPanel, Content, Bar, CloseButton } from './modal-styled';

/* ----------  Confirm popup for 3dSecure ----------  */

// Utils
import { publish, subscribe, unsubscribe } from '../../../../../utils/events'

const EVENT_NAME = 'PAYMENTS:SHOW_MODAL_IFRAME_3D_SECURE'

// data: {
//   url: string;
//   title: string;
// }
export const showModalIframe3DSecure = (data) => {
  return new Promise(() => {
    publish(EVENT_NAME, {
      data
    })
  })
}

export const ModalIframe3DSecure = () => {
  const [show, setShow] = useState(false)
  const [data, setData] = useState(null)
  const node = useRealNode('modal-node-portal')

  useEffect(() => {
    const listener = (event) => {
      const { data } = event.detail
      setData(data)
      setShow(true)
    }

    subscribe(EVENT_NAME, listener)

    return () => {
      unsubscribe(EVENT_NAME, listener)
    }
  }, [])

  const handleClose = (event) => {
    event.stopPropagation()
    event.preventDefault()

    setShow(false)
  }
  
  const stopPropagation = (event) => {
    event.stopPropagation()
  }

  if (!show || !node) return null

  return ReactDOM.createPortal(
    <ModalPanel tabIndex="1">
      <Content style={{ maxWidth: 600, minHeight: 200 }} onMouseDown={stopPropagation}>
        <Bar>
          {data?.title || '3D Secure'}
          <CloseButton onClick={handleClose}>
            <Iconify icon="ic:baseline-close" />
          </CloseButton>
        </Bar>
        <IframeContainer>
          <Iframe src={data?.url} />
        </IframeContainer>
      </Content>
    </ModalPanel>,
    node,
    data.title
  );
};

const IframeContainer = styled.div`
  width: 100%;
  padding: 0;
  overflow: hidden;
`;

const Iframe = styled.iframe`
  width: 100%;
  height: 700px;
  background-color: #fff;
  border: none;
  display: block;
`;
